import GLPostsTable from './GLPostsTable'
export default GLPostsTable
